import type { ExtractPropTypes, PropType } from 'vue'
import type { ComponentType } from '../../../constants'
import type _Status from './status.vue'

export const sdStatusProps = {
    type     : { type: String as PropType<ComponentType>, default: 'info' },
    text    : { type: String  , default: ''                               }, // 显示文字
} 

export type SdStatusProps    = ExtractPropTypes<typeof sdStatusProps>
export type SdStatusInstance = InstanceType<typeof _Status>


